module.exports = "/_next/static/images/df36a8bd71415a2c84e2dfe28d586377-roxinho-basicos-flutuantes-md@3x.png";